import styles from './DeliveryColorIndicator.module.css';
import type { FC } from 'react';
import { DeliveryColorIndicatorProps } from './DeliveryColorIndicator.types';

export const DeliveryColorIndicator: FC<DeliveryColorIndicatorProps> = ({
  color,
}) => {
  return (
    <div
      className={styles.deliveryColorIndicator}
      style={{ backgroundColor: color }}
    />
  );
};
